import { useContext, useEffect, useState } from 'react';
import AppContext from 'app/AppContext';
import { matchRoutes, useLocation, matchPath } from 'react-router-dom';
import withRouter from '@fuse/core/withRouter';
import history from '@history';
import FuseUtils from '@fuse/utils';
import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import {jwtDecode} from 'jwt-decode';
import { useSelector } from 'react-redux';
import routeConfigs from '@/app/configs/routesConfig';

const generallyAvailableRoutesRoutes = routeConfigs.filter((route) =>
  route.auth?.includes('Guest'),
);

const isAuthTokenValid = (access_token) => {
  const decoded = jwtDecode(access_token);
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    console.warn('access token expired');
    return false;
  }

  return true;
};

const FuseAuthorization = ({ children, userRole }) => {
  const [accessGranted, setAccessGranted] = useState(true);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const appContext = useContext(AppContext);
  const { routes } = appContext;
  const userToken = useSelector((state) => state?.auth?.userToken);
  const getTokenFetchCompleted = userToken !== undefined;

  useEffect(() => {
    if (getTokenFetchCompleted) {
      setLoading(false);
    }
  }, [getTokenFetchCompleted]);

  useEffect(() => {
    if (!userRole && !getTokenFetchCompleted) {
      return;
    }
    const { pathname } = location;
    const matchedRoutes = matchRoutes(routes, pathname);
    const matched = matchedRoutes[0];
    const generallyAvailableRoutes = generallyAvailableRoutesRoutes.some((route) =>
      matchPath(route.path, location.pathname),
    );

    if (generallyAvailableRoutes) {
      return setAccessGranted(true);
    }

    setAccessGranted(FuseUtils.hasPermission(matched.route.auth, userRole));
  }, [location, userRole, routes, getTokenFetchCompleted]);

  useEffect(() => {
    if (!userRole || !getTokenFetchCompleted) {
      return;
    }
    if (!accessGranted) {
      return redirectRoute();
    }
    if (!userToken && getTokenFetchCompleted) {
      return history.push('/sign-in');
    }
  }, [accessGranted, userRole, getTokenFetchCompleted]);

  const redirectRoute = () => {
    const { pathname } = location;
    try {
      isAuthTokenValid(userToken);
    } catch (e) {
      setTimeout(() => history.push('/sign-in'), 0);
    }
    const matchedRoutes = matchRoutes(routes, pathname);
    const matched = matchedRoutes[0];
    if (FuseUtils.hasPermission(matched.route.auth, userRole)) {
      return;
    }

    if (userRole === 'Company Owner') {
      history.push('/company-summary');
      return;
    }
    history.push('/orders');
  };

  if (loading) {
    return <FuseSplashScreen />;
  }

  return accessGranted ? <>{children}</> : <FuseSplashScreen />;
};

export default withRouter(FuseAuthorization);
